import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import NotificationManager from './NotificationManager';
import IdleManager from './IdleManager';

const ScrollToTop = ({ location, children }) => {
  const prevLocationRef = useRef(location);

  useEffect(() => {
    if (location !== prevLocationRef.current) {
      window.scrollTo(0, 0); // eslint-disable-line no-undef
      prevLocationRef.current = location;
    }
  }, [location]);

  return (
    <div>
      <NotificationManager />
      <IdleManager />
      {children}
    </div>
  );
};

ScrollToTop.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default withRouter(ScrollToTop);
